import { render, staticRenderFns } from "./GoodsServices.vue?vue&type=template&id=5be038ca&scoped=true&"
import script from "./GoodsServices.vue?vue&type=script&lang=js&"
export * from "./GoodsServices.vue?vue&type=script&lang=js&"
import style0 from "./GoodsServices.vue?vue&type=style&index=0&id=5be038ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be038ca",
  null
  
)

export default component.exports